module.exports = __webpack_public_path__ + "static/media/abertay.3ff32f5d.webp";